import Main from './SupplierStepMain'

export default { Main }
